<!--
 * @Author: M.D.
 * @Date: 2019-12-26 10:34:53
 * @LastEditors: M.D.
 * @Description: 商品详情
 * @Remarks: http://localhost:9001/product/1206808667391913986
 -->
<template>
  <div class="prd-detail-outer-w" v-if="product">
    <!-- head -->
    <div class="prd-detail-header bShadow-5">
      <div class="prd-d-h-l">
        <div class="prd-d-h-img-w">
          <!-- <img  v-show="!showVideo" :src="tImgUrl(product.image)" alt="" autoplay=true  arrow="always"> -->
          <video-player
            v-show="showVideo"
            style="width:100%; height: 630px"
            ref="videoPlayer"
            :playsinline="true"
            :options="playerOptions"
            @play="onPlayerPlay($event)"
            @pause="onPlayerPlay($event)"
            @ended="onPlayerPlay($event)"
            @timeupdate="onPlayerTimeupdate($event)"
            @loadeddata="onPlayerLoadeddata($event)"
          >
          </video-player>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { usrStatus } from '@/util/mixin'
import { mapGetters } from 'vuex'
import API from '@/api/api'
import GoodsComments from '@/components/goods-comments'

export default {
  mixins: [usrStatus],
  props: {},
  data() {
    return {
      orderType: '1',
      activeName: 'detail', // comments
      product: null,
      videoUrl: '',
      // 推荐
      recmdList: [],
      showVideo: false,
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            src: '', // 路径
            type: 'video/mp4', // 类型
          },
        ],
        width: document.documentElement.clientWidth,
        poster: '', // 你的封面地址
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, // 全屏按钮
        },
      },
      tczfc: [], //套餐字符数据
      tczhid: [], //套餐字符id
      title: '', // 标签名字,用来判断选中
      childGoods: [], //选中子商品数据
      goodsGroup: [], //全部子商品数据
      childGoodsDetail: null, //子商品详情数据
    }
  },
  computed: {
    ...mapGetters(['curLoc', 'memberInfo', 'userInfo']),
    player() {
      //return this.$refs.videoPlayer
    },
    prdTextRight() {
      let el = `<div>`
      if (this.product && this.product.data && this.product.data.obtailPoint) {
        el += `可获积分：<span style='color: #31A826'>${this.product.data.obtailPoint}</span>`
        if (this.product && this.product.saleNum != null) {
          el += ` | `
        }
      }
      // console.log("商品信息",this.product)
      if (this.product && this.product.saleNum != null) {
        // el += ` | `
        el += `销量${
          this.childGoodsDetail
            ? this.childGoodsDetail.saleNum
            : this.product.saleNum
        }`
      }

      if (this.product.type > 2) {
        console.log('no num')
        el += `</div>`
        return el
      }

      if (this.product && this.product.feedbackRate && this.product.saleNum) {
        // if (this.product && this.product.saleNum) {
        //   el += ` | `
        // }
        el += ` | `
        el += `好评率${this.product.feedbackRate * 100}%`
      }
      el += `</div>`
      return el
    },
    showFreeQuotaByUrl() {
      return (
        this.$route.query.displayFreeQuate !== '1' &&
        this.product &&
        this.product.data &&
        this.product.data.trainWay &&
        this.product.data.trainWay === 2 &&
        this.product.data.experiencePopulation
      )
    },
  },
  async created() {
    this.orderType = this.$route.params.type
    this.prdId = this.$route.params.prodId
    const re = await API.getPrdDetail(this.prdId)
    this.product = re.data.result
    console.log('商品信息', this.product)
    this.showVideo = this.product.videoUrl
    if (this.showVideo) {
      this.getUrlFromVideoUrl()
    }
    this.product.labelsArr = this._transformPrdLabel(this.product.label)
    this.product.imgArr = this._transformPrdImg(this.product.image)

    // 1转2 2转3 5转4  //
    // let currOdTp = (this.product.type === 1) ? 2 : ((this.product.type === 2) ? 3 : (this.product.type === 5) ? 4 : this.product.type)
    // 推荐同类同城的增值服务
    const Rre = await API.getRecmdByCateId({
      // type: this.orderType || currOdTp,
      type: 4,
      // cateId: this.product.cateId,
      cateId: '',
      cityCode: this.product.cityCode,
      pageSize: 5,
      currentPage: 1,
    })
    let array = []
    for (let i = 0; i < Rre.data.result.records.length; i++) {
      let it = Rre.data.result.records[i]
      if (it.id === this.prdId) {
        continue
      }
      array.push(it)
    }
    this.recmdList = array.splice(0, 4)
    // console.log(this.recmdList)

    // if (this.product.videoUrl) {
    //   this.showVideo = true
    // this.getUrlFromVideoUrl()
    // console.log(this.$refs)
    // this.player.source.src = process.env.VUE_APP_BASE_API + 'video/getVideo?goodsId=' + this.product.id
    // } else {
    //   this.showVideo = false
    // }
    // 存tczfc
    console.log(this.product, 'productproductproduct')
    if (this.product.tczfc == '') {
      this.product.tczfc = '[]'
    }
    this.tczfc = JSON.parse(this.product.tczfc)
    // 进入该商品时，通过商品id保存点击记录
    const clickRecord = await API.saveClickRecord({
      spid: this.$route.params.prodId,
      isJson: true,
    })
    console.log('点击记录', clickRecord)
    // 获取套餐分组
    this.getGoodsGroup()
  },
  mounted() {
    this.$refs.my - carousel.setActiveItem(1) //video
  },
  activated() {
    this.freeQuota = 0
  },
  deactivated() {},
  watch: {
    userInfo: function (v) {
      if (v) {
        this.getUrlFromVideoUrl()
      }
    },
  },
  methods: {
    getUrlFromVideoUrl() {
      let reg = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g
      if (reg.test(this.product.videoUrl)) {
        console.log('===============')
        this.playerOptions.sources[0].src = this.product.videoUrl
      } else {
        this.playerOptions.sources[0].src =
          process.env.VUE_APP_BASE_API +
          'video/getVideo?goodsId=' +
          this.product.id
      }
      // this.videoUrl = process.env.VUE_APP_BASE_API + 'video/getVideo?goodsId=' + this.product.id
      this.playerOptions.poster = this.tImgUrl(this.product.image.split(',')[0])
    },
    onPlayerLoadeddata(player) {
      // console.log('player Loadeddata!', player)
    },
    onPlayerTimeupdate(player) {
      // console.log(player.controlBar)
      // player.currentTime = player.controlBar
      // console.log('player Timeupdate!', player.currentTime())
    },
    onPlayerPlay(player) {
      if (!this.isLogin) {
        this.playerOptions.sources[0].src = ''
        this.$emit('openLoginDialog')
      } else {
        this.getUrlFromVideoUrl()
      }
      // console.log('player play!', player)
    },
    tabChg(v) {},
    async getFreeQuota() {
      if (!this.isLogin) {
        this.$emit('openLoginDialog')
        return
      }

      let loading = this.$loading({ fullscreen: true })
      try {
        let res = await API.decideVip(this.product.id)
        this.$nextTick(() => {
          // 以服务的方式调用的 Loading 需要异步关闭
          loading.close()
        })
        if (res.data.statusCode === '200') {
          this.toConfirmOrd(1)
        } else {
          this.errorMsg(res.data)
        }
      } catch (error) {
        this.$nextTick(() => {
          // 以服务的方式调用的 Loading 需要异步关闭
          loading.close()
        })
      }
    },
    errorMsg(res) {
      let msg = res.message
      // 非会员
      if (res.result === 1) {
        this.$confirm(msg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'waning',
        })
          .then(() => {
            // 跳转会员vip商品
            this.orderVipPrd(this.userInfo.cityCode, this)
          })
          .catch(() => {
            console.log('cancel')
          })
      } else {
        // 商品的免费兑换次数用尽
        this.$confirm(msg, '提示', {
          confirmButtonText: '普通购买',
          cancelButtonText: '取消',
          type: 'waning',
        })
          .then(() => {
            this.toConfirmOrd(0)
          })
          .catch(() => {
            console.log('cancel')
          })
      }
    },
    // 封装跳转数据方便复用
    async handleToComfirmOrd(freeQuota, prodId) {
      if (this.product.cateId == 300002) {
        //税筹产品
        this.$router.push({
          name: 'taxDecision', //税筹
          params: {
            prodId: this.$route.params.prodId,
            freeQuota: freeQuota,
          },
        })
        // return
      }
      if (!this.isLogin) {
        // this.eBus.$emit('showLogDialog')
        // this.$message('请登录')
        this.$emit('openLoginDialog')
        return
        // this.$refs.tpHeader.toLogin()
      }

      if (this.memberInfo.isPerfect && this.memberInfo.isPerfect === 1) {
        //需要完善信息 lyj
        this.$emit('openCompDialog')
        return
      }
      //商品类型 1服务 2培训 3兑换 4会员 5增值服务
      if (this.product.type === 5) {
        const loadngInstance = this.$loading({
          fullscreen: true,
        })
        try {
          const tsRes = await API.getThirdServiceUrl(this.product.id)
          if (tsRes.data.statusCode === '200') {
            let url = tsRes.data.result
            window.open(url, '_blank')
          } else {
            this.$message({
              message: tsRes.data.message,
              type: 'warning',
            })
          }
          this.$nextTick(() => {
            loadngInstance.close()
          })
        } catch (error) {
          this.$nextTick(() => {
            loadngInstance.close()
          })
        }
        return
      }
      this.$router.push({
        name: 'orderConfirm',
        params: {
          prodId: prodId,
          freeQuota: freeQuota,
        },
      })
    },
    async toConfirmOrd(freeQuota) {
      // 判断是否有子商品没有的话就跳转到主商品界面，有的话就必须选择了子商品才进行跳转
      if (this.product.tczfc.length < 3) {
        // 调用提交函数
        this.handleToComfirmOrd(freeQuota, this.$route.params.prodId)
        // 先清空存储防止主商品没有子商品数据会使用上一次的数据
        sessionStorage.setItem('childGoods', '')
        // pordId
        // this.$router.push({
        //   name: 'orderConfirm',
        //   params: {
        //     prodId: this.$route.params.prodId,
        //     freeQuota: freeQuota,
        //   },
        // })
        return
      }
      if (this.product.tczfc.length && this.childGoods.length) {
        // if (this.product.cateId == 300002) {
        //   //税筹产品
        //   this.$router.push({
        //     name: 'taxDecision', //税筹
        //     params: {
        //       pordId: this.$route.params.prodId,
        //       freeQuota: freeQuota,
        //     },
        //   })
        // }
        // if (!this.isLogin) {
        //   // this.eBus.$emit('showLogDialog')
        //   // this.$message('请登录')
        //   this.$emit('openLoginDialog')
        //   return
        //   // this.$refs.tpHeader.toLogin()
        // }

        // if (this.memberInfo.isPerfect && this.memberInfo.isPerfect === 1) {
        //   //需要完善信息 lyj
        //   this.$emit('openCompDialog')
        //   return
        // }
        // //商品类型 1服务 2培训 3兑换 4会员 5增值服务
        // if (this.product.type === 5) {
        //   const loadngInstance = this.$loading({
        //     fullscreen: true,
        //   })
        //   try {
        //     const tsRes = await API.getThirdServiceUrl(this.product.id)
        //     if (tsRes.data.statusCode === '200') {
        //       let url = tsRes.data.result
        //       window.open(url, '_blank')
        //     } else {
        //       this.$message({
        //         message: tsRes.data.message,
        //         type: 'warning',
        //       })
        //     }
        //     this.$nextTick(() => {
        //       loadngInstance.close()
        //     })
        //   } catch (error) {
        //     this.$nextTick(() => {
        //       loadngInstance.close()
        //     })
        //   }
        //   return
        // }
        // 调用提交函数
        this.handleToComfirmOrd(freeQuota, this.childGoods[0].zhspid)
        // 存储子商品数据
        sessionStorage.setItem('childGoods', JSON.stringify(this.childGoods))
        // this.$router.push({
        //   name: 'orderConfirm',
        //   params: {
        //     prodId: this.childGoods[0].zhspid,
        //     freeQuota: freeQuota,
        //   },
        // })
      } else {
        this.$message.warning('必须选择子商品')
        return
      }
    },
    _transformPrdLabel(label) {
      return label.trim() === '' ? '' : label.split(',').map((l) => l.trim())
    },
    _transformPrdImg(img) {
      return img.split(',').map((i) => this.tImgUrl(i))
    },
    _get1stPic(str) {
      const arr = str.split(',').map((i) => this.tImgUrl(i))
      return arr[0]
    },
    goToGdsDetail(i) {
      this.$router.push({ name: 'productDetail', params: { prodId: i.id } })
    },
    showFreeQuota() {
      // if (this.orderType === '4') {
      //   return false
      // }
      // if (!this.isLogin || !this.isVip) {
      //   return false
      // }
      // if (!this.product.data || !this.product.data.experiencePopulation || this.product.data.experiencePopulation < 1) {
      //   return false
      // }
      return true
    },
    // 标签页的点击事件
    async handleTag(title, value) {
      // 清空背景色数据
      this.tczfc.forEach((item) => {
        if (item.key == value.key) {
          item.children.forEach((item) => {
            if (item.effect) {
              item.effect = ''
            }
            // this.$set(item,"effect",'dark')
          })
          return
        }
      })
      // 给选中项加上主题颜色数据
      this.tczfc.forEach((item) => {
        item.children.forEach((item) => {
          if (item.title == title) {
            this.$set(item, 'effect', 'dark')
            return
          }
        })
      })
      // 下次选择前清空套餐字符id
      this.tczhid = []
      // 找出选中的项并处理成套餐字符id
      this.tczfc.forEach((item) => {
        item.children.forEach((itemChild) => {
          if (itemChild.effect) {
            this.tczhid.push(Number(`${item.key}.${itemChild.key}`))
          }
        })
      })
      // 处理套餐分组数据把tczhid转化成数组
      this.goodsGroup.forEach((item) => {
        // console.log(item.tczhid)
        if (!Array.isArray(item.tczhid)) {
          item.tczhid = JSON.parse(item.tczhid)
        } else {
          return
        }
      })
      // 循环判断套餐数组是否和选中项相同，相同则返回
      this.childGoods = this.goodsGroup.filter((item) => {
        for (let i = 0; i < item.tczhid.length; i++) {
          if (!(item.tczhid[i] == this.tczhid[i])) {
            break
          }
          if (i == this.tczhid.length - 1) {
            return item
          }
        }
      })
      if (this.childGoods.length > 1) {
        for (let i = 0; i < this.childGoods.length; i++) {
          this.childGoods.splice(i, 1)
          i--
        }
        return
      }
      // 选中了子商品则获取详细数据
      if (this.childGoods.length) {
        const { data } = await API.getPrdDetail(this.childGoods[0].zhspid)
        if (data.statusCode != 200) {
          this.$message.error(data.message)
          return
        }
        this.childGoodsDetail = data.result
        console.log('子商品详情数据', this.childGoodsDetail)
      }
    },
    // 获取套餐分组
    async getGoodsGroup() {
      // 处理参数
      const query = {
        zspid: this.prdId,
        isJson: true,
      }
      const {
        data: { result },
      } = await API.getGoodsGroup(query)
      this.goodsGroup = result
    },
  },
  components: {
    GoodsComments,
  },
}
</script>

<style lang="stylus" scoped>
.prd-detail-outer-w {
  width: 1200px;
  margin: auto;

  .prd-detail-header {
    box-sizing: border-box;
    padding: 20px;
    height: auto;
    background-color: #ffffff;
    margin-bottom: 20px;
    display: flex;
    min-height: 300px;

    .prd-d-h-l {
      width: 100%;
      height: fit-content;
      position: relative;
      margin: 0 30px 0 20px;
      min-height: 300px;
      center();

      .prd-d-h-img-w {
        width: 100%;
        position: relative;
        overflow: hidden;
        font-size: 0;
        margin: 0 auto;
        display: flex;
        justify-content: center;

        .prd-d-h-img-item {
          goods-img-image();
          height: 100%;
        }
      }
    }
  }
}
</style>
<style lang="stylus">
.prd-detail-outer-w {
  .vjs-big-play-button {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin:auto;
  }
}
</style>
